import api from '@/apis/di/inventoryItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useInventoryItemCustomComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onInventoryItemCustomComboboxLoadData = (payload, row, column) => {
    payload.sort = 'inventory_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_tool', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_tool', Value: false, Ors: ors1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const inventoryItemCustomComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã hàng',
        dataField: 'inventory_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên hàng',
        dataField: 'inventory_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'inventory_item_code',
    valueField: 'inventory_item_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onInventoryItemCustomComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    inventoryItemCustomComboConfig,
    onInventoryItemCustomComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
